class VivierAccordion extends HTMLElement {
  get details() { return this.querySelector('details'); }
  get summary() { return this.details.querySelector('summary'); }

  // Private listener for the 990px bridge
  #vivierQuery = window.matchMedia('(max-width: 989px)');

  connectedCallback() {
    this.#updateState();
    this.summary.addEventListener('click', this.#handleClick);
    // Watch for the resize bridge
    this.#vivierQuery.addEventListener('change', () => this.#updateState());
  }

  #handleClick = (event) => {
    const isMobile = this.#vivierQuery.matches;
    if ((isMobile && this.dataset.disableOnMobile === 'true') || 
        (!isMobile && this.dataset.disableOnDesktop === 'true')) {
      event.preventDefault();
    }
  };

  #updateState() {
    const isMobile = this.#vivierQuery.matches;
    if (isMobile && this.hasAttribute('open-by-default-on-mobile')) {
      this.details.open = true;
    } else if (!isMobile && this.hasAttribute('open-by-default-on-desktop')) {
      this.details.open = true;
    }
  }
}
if (!customElements.get('vivier-accordion')) {
  customElements.define('vivier-accordion', VivierAccordion);
}